import { render, staticRenderFns } from "./TypeInsurances.vue?vue&type=template&id=097e5f02&scoped=true"
import script from "./TypeInsurances.vue?vue&type=script&lang=js"
export * from "./TypeInsurances.vue?vue&type=script&lang=js"
import style0 from "./TypeInsurances.vue?vue&type=style&index=0&id=097e5f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e5f02",
  null
  
)

export default component.exports